import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIssueAssemble = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "m8.84 3 14.202 2.504-1.29 7.316L7.55 10.316 8.84 3zm1.623 2.317 10.262 1.81-.595 3.376-10.263-1.81.596-3.376zM1 14.675l14.201-2.505 1.29 7.316L2.29 21.991 1 14.675zm2.317 1.622 10.262-1.81.596 3.377-10.263 1.81-.595-3.377z",
		clipRule: "evenodd"
	})
});
export default SvgIssueAssemble;
